<template>
  <div>
    <div
      v-if="!isOnMobile()"
      class="pdf-preview-share"
      :class="{ maximized: maximized === true || mobile}"
    >
      <div class="top-bar">
        <button
          v-if="!mobile"
          class="expand-button"
          :class="{ maximized: maximized === true}"
          @click="toggleMaximize()"
        >
          <svg
            fill="#FFFFFF"
            width="16px"
            height="16px"
            enable-background="new 0 0 384 384"
            version="1.1"
            viewBox="0 0 384 384"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m373.33 0h-234.67c-5.896 0-10.667 4.771-10.667 10.667s4.771 10.667 10.667 10.667h208.92l-344.46 344.46c-4.167 4.167-4.167 10.917 0 15.083 2.083 2.083 4.813 3.125 7.542 3.125s5.458-1.042 7.542-3.125l344.46-344.46v208.92c0 5.896 4.771 10.667 10.667 10.667s10.667-4.771 10.667-10.667v-234.67c-1e-3 -5.896-4.772-10.667-10.668-10.667z" />
          </svg>
        </button>
      </div>
      <pdf-preview :url="url" />
    </div>
    <div v-if="isOnMobile()">
      <slot name="on-mobile" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'pdf-preview-share',
  props: {
    url: String,
  },
  data() {
    return {
      maximized: Boolean,
      mobile: false
    }
  },
  methods: {
    isOnMobile() {
      return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
      )
    },
    toggleMaximize() {
      if (this.maximized) {
        this.maximized = false
        document.body.classList.remove('modal-opened')
      } else {
        this.maximized = true
        document.body.classList.add('modal-opened')
      }
    }
  }
}
</script>
